import { render } from "./add-user.vue?vue&type=template&id=c879c422&ts=true"
import script from "./add-user.vue?vue&type=script&lang=ts"
export * from "./add-user.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__